import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TinyColor } from '@ctrl/tinycolor';
import { ThemingManegerService } from './theming-maneger/theming-maneger.service';

// const tinycolor = new TinyColor('red');

// @NgModule({
//   declarations: [],
//   imports: [
//     CommonModule
//   ]
// })

@Injectable({
  providedIn: 'root'
})

export class ColorPaletteGeneratorService {

  public themingManegerService: ThemingManegerService = new ThemingManegerService();

  public themeData: any = {
    rbMainPalette: {
      colors: [],
      orig: [],
      base: '#10807f',
      json: '',
      name: '',
      angularCodeString: '',
    },
    rbAccentPalette: {
      colors: [],
      orig: [],
      base: '#717171',
      json: '',
      name: '',
      angularCodeString: '',
    },
  };


  setThemeData(data) {
    if (data) {
      this.themeData = JSON.parse(JSON.stringify(data));
    } else {
      this.themeData = this.resetOriginalValues();
    }
  }

  getThemeData() {
    return JSON.parse(JSON.stringify(this.themeData));
  }

  resetOriginalValues() {
    return {
      rbMainPalette: {
        colors: [],
        orig: [],
        base: '#10807f',
        json: '',
        name: ''
      },
      rbAccentPalette: {
        colors: [],
        orig: [],
        base: '#717171',
        json: '',
        name: '',
        angularCodeString: '',
      },
    };
  }

  changePalette(value, colorBaseObj, colorBaseModel, parentScope, paletteSettings) {
    const hexValue = new TinyColor(parentScope[paletteSettings].base).toHexString();
    colorBaseObj[colorBaseModel] = hexValue;
    parentScope[paletteSettings].colors =  this.buildNewPalette(hexValue);
    this.createPaletteStrCode(parentScope[paletteSettings].colors, parentScope, paletteSettings);

    if (parentScope && typeof parentScope.setHasChange === 'function') {
      parentScope.setHasChange(value);
    }
  }

  buildNewPalette(hex) {
      const lightBase = new TinyColor('#ffffff');
      const darkBase = this.buildDarkBase(new TinyColor(hex).toRgb(), new TinyColor(hex).toRgb());
      const triadbase = new TinyColor(hex).tetrad();
      return [
        this.getColorObject(this.rbMixColor(lightBase, hex, 12), '50'),
        this.getColorObject(this.rbMixColor(lightBase, hex, 30), '100'),
        this.getColorObject(this.rbMixColor(lightBase, hex, 50), '200'),
        this.getColorObject(this.rbMixColor(lightBase, hex, 70), '300'),
        this.getColorObject(this.rbMixColor(lightBase, hex, 85), '400'),
        this.getColorObject(this.rbMixColor(lightBase, hex, 100), '500'),
        this.getColorObject(this.rbMixColor(darkBase, hex, 87), '600'),
        this.getColorObject(this.rbMixColor(darkBase, hex, 70), '700'),
        this.getColorObject(this.rbMixColor(darkBase, hex, 54), '800'),
        this.getColorObject(this.rbMixColor(darkBase, hex, 25), '900'),
        this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(80).lighten(65), 'A100'),
        this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(80).lighten(55), 'A200'),
        this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(100).lighten(45), 'A400'),
        this.getColorObject(this.rbMixColor(darkBase, triadbase[4], 15).saturate(100).lighten(40), 'A700')
      ];
  }

  buildDarkBase(rgb1, rgb2) {
    rgb1.b = Math.floor(rgb1.b * rgb2.b / 255);
    rgb1.g = Math.floor(rgb1.g * rgb2.g / 255);
    rgb1.r = Math.floor(rgb1.r * rgb2.r / 255);
    return new TinyColor('rgb ' + rgb1.r + ' ' + rgb1.g + ' ' + rgb1.b);
  }

  getColorObject(value: any, name: any) {
    const c = new TinyColor(value);
    return {
      name: name,
      hex: c.toHexString(),
      hexValue: c.toHex(),
      rgbValue: c.toRgb(),
      rgbString: c.toRgbString(),
      darkContrast: c.isLight()
    };
  }

  rbMixColor(baseLight, hex, value) {
    return baseLight.mix(hex, value);
  }

  refreshColor(value, colorBaseObj, colorBaseModel, parentScope, paletteSettings) {
    if (!value || value === '') {
      colorBaseObj[colorBaseModel] = '#10807f';
    } else {
      colorBaseObj[colorBaseModel] = value;
    }
    parentScope[paletteSettings].base = colorBaseObj[colorBaseModel];
    this.changePalette(0, colorBaseObj, colorBaseModel, parentScope, paletteSettings);
  }

  createPaletteStrCode(arrayColors, parentScope, paletteSettings) {
    const colors = [];
    let palleteCode = '$md-mcgpalette0:( ';
    palleteCode += `
        `;

    for (const item of arrayColors) {
      palleteCode += item.name + ' : ' + item.hex + ', ';
      palleteCode += `
        `;
    }
    palleteCode += 'contrast: (';
    palleteCode += `
          `;
    for (const item of arrayColors) {
      palleteCode += item.name + ' : ' + (item.darkContrast ? '#000000' : '#ffffff') + ', ';
      if ( item + 1 < arrayColors.length) {
        palleteCode += `
          `;
      } else {
        palleteCode += `
        `;
      }
    }
    palleteCode += `)
    );`;
    parentScope[paletteSettings].angularCodeString = palleteCode;
  }

  changeTheme(newTheme, theme) {
    this.themingManegerService.changeTheme(newTheme);
    this.setThemeData(theme);
  }
}
